import styled from 'styled-components';
import Button from '@material-ui/core/Button';

export const PlanButton = styled(Button)`
  ${({ theme: { palette, colors } }) => `
    width: 100%;
    color: #003C3B;
    background-color: #FFF;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    opacity: 0.9;

    &.MuiButton-contained {
      padding: 10px 8px;
    }
  `}
`;

export const KIDButton = styled(Button)`
  ${({ theme: { palette, colors } }) => `
  width: 100%;
  color: #003C3B;
  font-size: 11px;
  line-height: 17px;
  font-weight: 400;
  border: 1px solid #003C3B;
  background-color: transparent;
  border-radius: 3px !important;
  // &:hover {
  //   background-color: #003C3B; 
  // }

  &.MuiButton-contained {
    padding: 10px 8px;
  }
`}
`;

export const DownloadButton = styled(Button)`
  ${({ theme: { palette, colors } }) => `
    width: 60%;
    color: ${palette.primary.main};
    background-color: ${colors.greys.greys3};
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    opacity: 0.9;

    &.MuiButton-contained {
      padding: 10px 8px;
    }
  `}
`;

export const RegisterButton = styled(Button)`
  ${({ theme: { palette } }) => `
    width: 100%;
    color: ${palette.common.white};
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    background-color: #003C3B;
    border-radius: 17px !important;
    &:hover {
      background-color: #003C3B;
      opacity: 0.9;
    }

    &.MuiButton-contained {
      padding: 10px 8px;
    }
  `}
`;
